import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Transform Your Space</h1>
        <p className="hero-subtitle">Discover Premium Lighting & Home Decor</p>
      </div>
    </section>
  );
};

export default Hero;